/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_ResetInputs */

const en_control_planner_reset = /** @type {(inputs: Control_Planner_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset all`)
};

const zh_control_planner_reset = /** @type {(inputs: Control_Planner_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置配置`)
};

/**
* | output |
* | --- |
* | "Reset all" |
*
* @param {Control_Planner_ResetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_reset = /** @type {((inputs?: Control_Planner_ResetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_ResetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_reset(inputs)
	return zh_control_planner_reset(inputs)
});
export { control_planner_reset as "control.planner.reset" }